$(document).ready(function() {
  
 $(document).on('click', '.product-feature-one', function() {
    $('.product-year-guarantee-popup-overlay').addClass('active');
    $('.product-year-guarantee-popup').addClass('active');
    $('body').addClass('overflow-hidden');
  });

  $(document).on('click', '.product-year-guarantee-popup-overlay', function() {
    $('.product-year-guarantee-popup-overlay').removeClass('active');
    $('.product-year-guarantee-popup').removeClass('active');
    $('body').removeClass('overflow-hidden');
  });

   $(document).on('click', '.product-delivery-popup-overlay', function() {
    $('.product-delivery-popup-overlay').removeClass('active');
    $('.product-delivery-popup').removeClass('active');
    $('body').removeClass('overflow-hidden');
  });

   $(document).on('click', '.year-guarantee-popup-icon-close', function() {
    $('.product-year-guarantee-popup-overlay').removeClass('active');
    $('.product-year-guarantee-popup').removeClass('active');
    $('body').removeClass('overflow-hidden');
  });

   $(document).on('click', '.product-feature-two', function() {
    $('.product-delivery-popup-overlay').addClass('active');
    $('.product-delivery-popup').addClass('active');
    $('body').addClass('overflow-hidden');
  });

  $(document).on('click', '.delivery-popup-icon-close', function() {
    $('.product-delivery-popup-overlay').removeClass('active');
    $('.product-delivery-popup').removeClass('active');
    $('body').removeClass('overflow-hidden');
  });

   $(document).on('click', '.product-feature-one', function() {
      $('.product-year-guarantee-popup-overlay').addClass('active');
      $('.product-year-guarantee-popup').addClass('active');
  });

   $(document).on('click', '.product-feature-two', function() {
      $('.product-delivery-popup-overlay').addClass('active');
      $('.product-delivery-popup').addClass('active');
  });

  $(document).mouseup(function (e) {
    var container = $('.product-year-guarantee-popup-wrapper');
    if (!container.is(e.target) && container.has(e.target).length === 0 && $('.product-year-guarantee-popup').hasClass('active')) {
      $('.product-year-guarantee-popup').removeClass('active');
        $('body').removeClass('overflow-hidden');
    }
   });

   $(document).mouseup(function (e) {
    var container = $('.product-delivery-popup-wrapper');
    if (!container.is(e.target) && container.has(e.target).length === 0 && $('.product-delivery-popup').hasClass('active')) {
      $('.product-delivery-popup').removeClass('active');
        $('body').removeClass('overflow-hidden');
    }
   });

});